import React from "react";

import { Box } from "@whoosh/design-system/src/components/primitive";
import { WhooshThemeColors } from "@whoosh/design-system/src/theme/restyle/theme";

import { Avatar as ActualAvatar } from "../../../../components/display";

type AvatarProps = {
  player: {
    profileImagePublicId?: string;
    firstName: string | null;
    lastName: string | null;
  };
  mainColor: WhooshThemeColors;
  isLast: boolean;
};

export const Avatar = ({ player, mainColor, isLast }: AvatarProps) => {
  return (
    <Box
      borderWidth={1.5}
      borderRadius="1"
      borderStyle={"solid"}
      borderColor={mainColor}
      mr={isLast ? 0 : "-10"}
    >
      <ActualAvatar
        type="primary"
        profileImagePublicId={player.profileImagePublicId}
        firstName={player.firstName}
        lastName={player.lastName}
        size="tiny"
        useIcon
      />
    </Box>
  );
};
